import React, { useMemo, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import StripeCardForm from "./stripe-card-form";
import { message } from "@dreambigger/design-system";
import { DonationForm } from "../views/donate";
import { Community, Event as EventType } from "@dreambigger/shared/src/types";

export interface StripePaymentFormProps {
  stripeAccount?: string;
  formData: DonationForm;
  event: EventType;
  community: Community;
  setPaymentComplete: (value: boolean) => void;
}

const StripeCardPayment = ({
  stripeAccount,
  formData,
  event,
  community,
  setPaymentComplete,
}: StripePaymentFormProps) => {
  // Show error in useEffect to avoid side effects during render
  useEffect(() => {
    if (!stripeAccount) {
      message.error("Stripe account not found");
    }
  }, [stripeAccount]);

  // Memoize loadStripe to prevent creating new Promise on every render
  const stripePromise = useMemo(() => {
    if (!stripeAccount) return null;
    return loadStripe(stripeAccount);
  }, [stripeAccount]);

  if (!stripeAccount || !stripePromise) {
    return null;
  }

  return (
    <Elements stripe={stripePromise}>
      <StripeCardForm
        formData={formData}
        event={event}
        community={community}
        setPaymentComplete={setPaymentComplete}
      />
    </Elements>
  );
};

export default StripeCardPayment;
